export default __webpack_public_path__ + "static/media/comments.85b89168.svg";